export const sectionHeadingGlobals = {
  variant: "text.heading",
  fontFamily: "condensed",
  fontWeight: "semiBold",
  textTransform: "uppercase",
  letterSpacing: 9,
}
